import { useRouter } from 'next/router';
import { useEffect } from 'react';

import useClientAccountProfileQuery from '../queries/useClientAccountProfileQuery';
import type { StringifyObject } from '../utils/typeUtil';
import useNextUrlState from './useNextUrlState';

export default function useBlockNonAdminAccess() {
  const router = useRouter();

  const { data: accountProfile, isLoading } = useClientAccountProfileQuery({
    keepPreviousData: true,
  });
  const { value: pageParams } = useNextUrlState<StringifyObject<{ userId: number }>>();

  const isAdmin = accountProfile?.isAdmin || false;
  const hasUserIdPageParam = !!pageParams.userId;

  useEffect(
    function blockNonAdminAccess() {
      if (isLoading) {
        return;
      }

      if (!isAdmin && hasUserIdPageParam) {
        void router.replace(router.pathname);
      }
    },
    [isLoading, isAdmin, hasUserIdPageParam],
  );
}
